/* eslint-disable @typescript-eslint/no-explicit-any */
import { setupCore, openBrowserPlatform, raiseIONotification } from "./worker";

if (typeof self !== "undefined") {
    (self as any).IOWorker = setupCore;
    (self as any).openBrowserPlatform = openBrowserPlatform;
    (self as any).raiseIONotification = raiseIONotification;
}

export { openBrowserPlatform, raiseIONotification } from "./worker";

export default setupCore;
